import React, { useCallback, useEffect, useState } from 'react';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import Search from '../../shared/components/ui/Search';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import Table from '../../shared/components/layout/Table';
import { transformData } from '../../super-admin/utils/transformData';
import { AddMaterials } from '../components/forms/AddMaterials';
import Modal from '../../shared/components/ui/Modal';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useForm } from 'react-hook-form';
import { filterData } from '../../shared/utils/filterData';
import { AddBrands } from '../components/forms/AddBrands';
import {
  getAllCategories,
  deleteCategory,
  handleCheckCategoryDelete
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import { ItemList } from '../components/layout/ItemList';

import NoDataFound from '../components/layout/NoDataFound';
import PaginationComponent from '../../shared/components/PaginationComponent';
import DeleteConfirmationModal from '../components/ui/DeleteConfirmationModal';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const MaterialList = () => {
  const userId = Cookies.get('userId');
  const navigate = useNavigate();

  // Local state
  const [OpenAddMaterial, setOpenAddMaterial] = useState(false);
  const [isOpenEditMaterial, setIsOpenEditMaterial] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [materials, setMaterials] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isOpenAddBrands, setIsOpenAddBrands] = useState(false);
  const [selectedMaterialBrands, setSelectedMaterialBrands] = useState([]);
  const [categoryIdForBrands, setCategoryIdForBrands] = useState(null);
  const [isOpenItemList, setIsOpenItemList] = useState(false);
  const [selectedMaterialItems, setSelectedMaterialItems] = useState([]);
  const [canDelete, setCanDelete] = useState(null);
  const [resData, setResData] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [categoryIdForEdit, setCategoryIdForEdit] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // pagination
  const [limit] = useState(100000); // items per page
  const { collapsed } = useSidebar();
  const {
    data: allcategory,
    refetch: refetchAllcategory,
    isFetching
  } = useQuery({
    queryKey: ['category'],
    queryFn: () => getAllCategories(1, limit),
    keepPreviousData: true
  });

  const totalPages = allcategory?.meta ? Math.ceil(allcategory?.meta.total / limit) : 1;

  // Track page view
  useEffect(() => {
    mixpanel.track('Material List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (allcategory?.data) {
      refetchAllcategory();
    }
  }, [allcategory?.data]);

  console.log('All Materials', allcategory);

  useEffect(() => {
    if (allcategory?.data) {
      setMaterials(allcategory?.data);
      setFilteredData(allcategory?.data);
    }
  }, [allcategory?.data]);

  const handleSearch = (data) => {
    setSearchQuery(data);
  };

  const handleOnClickSearch = () => {
    const filtered = materials.filter((item) =>
      item.category_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredData(filtered);
    setSearchQuery('');
  };

  const handleToggleAddMaterial = () => {
    setOpenAddMaterial(!OpenAddMaterial);
    console.log('Add Material close');
  };

  const handleToggleEditMaterial = (id) => {
    setCategoryIdForEdit(id);
    setIsOpenEditMaterial(!isOpenEditMaterial);
    // refetchAllcategory();
    //page reload
  };

  const handleNavigateMaterial = (id) => {
    console.log('Navigate to material', id);
    navigate(`/builder/vendors/${id}`);
  };

  const handleDeleteMaterial = (materialId) => {
    const updatedMaterials = filteredData.filter((material) => material.categoryId !== materialId);
    setMaterials(updatedMaterials);
    setFilteredData(updatedMaterials);
    toast.success('Material deleted successfully');
  };

  const materialsDataFormat = ['id', 'name', 'itemList', 'brandList', 'actions'];

  const { reset } = useForm();

  useEffect(() => {
    setFilteredData(materials);
  }, [materials]);

  const handleSearchChange = useCallback(
    (incomingQuery) => {
      if (incomingQuery) {
        const filteredMaterials = filterData('name', materials, incomingQuery);
        setFilteredData(filteredMaterials);
      } else {
        setFilteredData(materials);
      }
    },
    [materials]
  );

  const onSubmit_Material = (data) => {
    toast.success('Material created successfully');
    reset();
    refetchAllcategory();
  };

  const handleOnViewBrands = (id) => {
    console.log('View Brands', id);
    const selectedMaterial = materials.find((material) => parseInt(material.id) === parseInt(id));
    console.log(selectedMaterial);
    const selectedCategoryId = selectedMaterial.id;
    setCategoryIdForBrands(selectedCategoryId);
    setSelectedMaterialBrands(selectedMaterial.brands);
    setIsOpenAddBrands(true);
  };

  const handleOnViewItems = (id) => {
    console.log('View Items', id);
    const selectedMaterial = materials.find((material) => parseInt(material.id) === parseInt(id));
    console.log(selectedMaterial, 'selectedMaterial');
    setSelectedMaterialItems(selectedMaterial.items);
    setIsOpenItemList(true);
  };

  const DataList =
    filteredData && filteredData.length > 0
      ? filteredData?.map((item) =>
          transformData(
            { ...item, actions: item.typeProp == 'Actions' ? '' : 'Actions' },
            materialsDataFormat
          )
        )
      : [];

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    allcategory?.data && allcategory?.data?.length > 0
      ? allcategory?.data?.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  const handlePageChange = (newPage) => {
    setSearchQuery('');
    setCurrentPage(newPage);
  };

  const transformedData =
    currentItems && currentItems.length > 0
      ? currentItems?.map((item) =>
          transformData(
            { ...item, actions: item.typeProp == 'Actions' ? '' : 'Actions' },
            materialsDataFormat
          )
        )
      : [];

  //delete functions

  const { mutate: handleCheckDelete } = useMutation({
    mutationFn: (id) => handleCheckCategoryDelete(id),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async (res, id) => {
      setIsSubmitting(false);
      const category = DataList?.find((item) => parseInt(item.id) === parseInt(id));

      const categoryName = category?.name || 'category';
      if (res.canDelete) {
        setCanDelete('yes');
        setResData({ name: categoryName });
        setSelectedIds([parseInt(id)]);
      } else {
        // Fallback if not found
        setResData({ ...res, name: categoryName });
        setCanDelete('no');
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error checking category', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error checking category');
    }
  });

  const { mutate: handleDeleteFn } = useMutation({
    mutationFn: (payload) => deleteCategory(payload),
    onMutate: () => {
      setIsSubmitting(true); // Disable the button when mutation starts
    },
    onSuccess: async () => {
      setIsSubmitting(false);
      toast.success('Category Deleted Successfully');

      // Refetch the data
      const result = await refetchAllcategory();

      // Check if the current page is now empty
      const updatedData = result?.data?.data || [];
      const totalItems = updatedData.length;
      const totalPages = Math.ceil(totalItems / itemsPerPage);

      if (currentPage > totalPages && totalPages > 0) {
        setCurrentPage(totalPages); // Go to last valid page
      }
    },
    onError: (err) => {
      setIsSubmitting(false);
      console.error('Error deleting category', err);
      toast.error(err?.response?.data?.message || err?.message || 'Error deleting category');
    }
  });

  const HandleDelete = (data) => {
    const payload = { ids: data };
    handleDeleteFn(payload);
  };

  return (
    <>
      {OpenAddMaterial && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={40}
          name="Add Materials"
          onClose={handleToggleAddMaterial}>
          <AddMaterials
            onSubmit={onSubmit_Material}
            onClose={handleToggleAddMaterial}
            onSuccess={refetchAllcategory}
          />
        </Modal>
      )}

      {isOpenAddBrands && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={56}
          name="Brand List"
          onClose={() => setIsOpenAddBrands(false)}>
          <AddBrands brandList={selectedMaterialBrands} categoryId={categoryIdForBrands} />
        </Modal>
      )}
      {isOpenItemList && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={56}
          name="Item List"
          onClose={() => setIsOpenItemList(false)}>
          <ItemList itemList={selectedMaterialItems} />
        </Modal>
      )}

      {isOpenEditMaterial && (
        <Modal
          isDirty={true}
          confirmOnClose={true}
          width={40}
          name="Edit Material"
          onClose={() => setIsOpenEditMaterial(false)}>
          <AddMaterials
            onSubmit={onSubmit_Material}
            onClose={handleToggleEditMaterial}
            onSuccess={refetchAllcategory}
            id={categoryIdForEdit}
          />
        </Modal>
      )}

      {canDelete === 'no' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={`Cannot delete '${resData?.name || 'this category'}'`}
          onClose={() => setCanDelete(null)}
          width={45}>
          <div className="flex flex-col justify-center align-center ">
            <p className="text-center">
              Looks like this category has dependencies, Please delete following vendor and
              requirements to proceed
            </p>
            <div className="flex justify-start, align-middle flex-wrap bg-[#f5f7f8] p-2 rounded-[5px] mt-4">
              {resData &&
                resData.reason?.map((r, index) => (
                  <span className="mt-[2px] mr-[4px] text-[#535353]" key={index}>
                    {index + 1}.{r}
                    {index < resData.reason.length - 1 ? ', ' : ''}
                  </span>
                ))}
            </div>
          </div>
        </Modal>
      )}

      {canDelete === 'yes' && (
        <Modal
          isDirty={true}
          confirmOnClose={false}
          name={'Confirmation'}
          onClose={() => {
            setCanDelete(null);
            setSelectedIds([]);
          }}
          width={45}>
          <DeleteConfirmationModal
            name={resData.name}
            title={'category'}
            onClose={() => setCanDelete(null)}
            data={DataList}
            type={'category'}
            setCanDelete={setCanDelete}
            onDeleteClick={HandleDelete}
            setSelectedIds={setSelectedIds}
            selectedIds={selectedIds}
          />
        </Modal>
      )}

      <Layout>
        <div
          className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
            collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
          }`}>
          <Header data={{ name: 'Materials' }} />
        </div>

        {transformData && transformedData?.length > 0 ? (
          <>
            <div
              className={`flex z-20 items-center justify-between px-6 py-4 bg-white fixed top-[4rem] border-t-[2px] border-stone-100 shadow-sm transition-all duration-300 ease-in-out ${
                collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
              }`}>
              <Search
                onChange={handleSearchChange}
                query={searchQuery}
                onClick={handleOnClickSearch}
              />
              <div className="flex gap-5 cursor-pointer items-center">
                <Button onClick={handleToggleAddMaterial}>Add Material</Button>
              </div>
            </div>

            <GridWrapper width={100}>
              <div className="table-container mt-[10rem] h-[calc(100vh-12rem)] overflow-auto">
                <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>
                <Table
                  headers={['Category', 'Items', 'Brands', 'Action']}
                  data={transformedData}
                  identifier={'id'}
                  onEdit={handleToggleEditMaterial}
                  onView={handleNavigateMaterial}
                  // isDeleteEnable={true}
                  isEditEnable={true}
                  onViewBrands={handleOnViewBrands}
                  onViewItems={handleOnViewItems}
                  isDeleteEnable={true}
                  onDelete={handleCheckDelete}
                />
                <PaginationComponent
                  page={currentPage}
                  totalPages={Math.ceil(filteredData?.length / itemsPerPage)}
                  onPageChange={handlePageChange}
                  isFetching={isFetching}
                />
              </div>
            </GridWrapper>
          </>
        ) : (
          <NoDataFound buttonText="Add Material" onButtonClick={handleToggleAddMaterial} />
        )}
      </Layout>
    </>
  );
};

export default MaterialList;
